/**
 * Trading-related constants
 * Centralized configuration for fees, layout dimensions, and trading parameters
 */

/**
 * Trading fees (as decimals, not percentages)
 */
export const TRADING_FEES = {
  TAKER: 0.0005, // 0.05%
  MAKER: 0.0002, // 0.02%
} as const;

/**
 * Layout constants for consistent spacing and dimensions
 */
export const LAYOUT_CONSTANTS = {
  /** Height of mobile footer menu in pixels */
  MOBILE_FOOTER_HEIGHT: 72,

  /** Height of desktop sidebar in pixels */
  DESKTOP_SIDEBAR_WIDTH: 240,

  /** Maximum number of orderbook levels to display */
  MAX_ORDERBOOK_LEVELS: 10,

  /** Gap between major layout sections (in Tailwind spacing units) */
  SECTION_GAP: 2, // 8px (gap-2)
} as const;

/**
 * Grid templates for responsive layouts
 */
export const GRID_TEMPLATES = {
  /** Mobile orderbook side-by-side layout: [Bid Price, Bid Size, Ask Size, Ask Price] */
  MOBILE_ORDERBOOK: "grid-cols-[1fr_auto_auto_1fr]",

  /** Desktop market list layout: [Star, Pair, Price, Change, Volume] */
  DESKTOP_MARKET_LIST: "grid-cols-[40px_1fr_140px_100px_120px]",

  /** Mobile market list layout: [Star, Pair/Info, Price] */
  MOBILE_MARKET_LIST: "grid-cols-[40px_1fr_auto]",
} as const;

/**
 * WebSocket configuration
 */
export const WEBSOCKET_CONFIG = {
  /** Hyperliquid WebSocket URL */
  HYPERLIQUID_WS_URL: "wss://api.hyperliquid.xyz/ws",

  /** Heartbeat interval in milliseconds (50 seconds, server timeout is 60s) */
  HEARTBEAT_INTERVAL: 50_000,

  /** Pair availability timeout in milliseconds */
  PAIR_UNAVAILABILITY_TIMEOUT: 10_000,

  /** Throttle delay for orderbook updates in milliseconds */
  ORDERBOOK_THROTTLE_DELAY: 100,

  /** Reconnection delay after disconnect in milliseconds */
  RECONNECT_DELAY: 5_000,
} as const;

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  /** Hyperliquid Info API */
  HYPERLIQUID_INFO: "https://api.hyperliquid.xyz/info",
} as const;

/**
 * Balance and data refresh intervals
 */
export const BALANCE_DEFAULT_TTL = 20 * 1000; // 20 seconds

/**
 * Asset selector sublist titles for categorizing tokens
 */
export const ASSETS_TO_SUBLIST_TITLES = {
  popular: "Trending tokens",
  rest: "All tokens",
  campaign: "Tokens",
} as const;
